import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/rootReducer';
import { loadCountries } from 'redux/reducers/countries';
import { ICountryFlagProps } from 'types/shared';
import { useEffect } from 'react';

const useCountries = (): ICountryFlagProps[] => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadCountries());
  }, [dispatch]);

  const countries = useSelector((rootState: RootState): ICountryFlagProps[] => {
    return rootState.countries.data;
  });

  return countries;
};

export default useCountries;
